/* eslint-disable import/first */
import React from 'react';
import Icon from '../modules/layout/components/Icon';

export default { title: 'Icon' };

export const defaultIcon = () => <Icon type={'user'} />;
export const iconWithColor = () => <Icon type={'user'} color={'red'} />;
export const iconRotated = () => <Icon rotate type={'user'} />;
